/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { IDmpConfiguration } from "@almamedia/amr-adtech-stack/lib/services/dmp/almadmp";
import { ICustomVariables } from "../data-layer/data-layer";
import { StackContext } from "../context";
import { SiteNativeTemplate } from "../native/native";

async function preDataCollection(context: StackContext) {
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const dl = context.services.dataLayerService!.dataLayer;
  if (dl.subCategory !== "koronavirus" && dl.primaryCategory !== "etusivu") {
    return { props: {} };
  }

  return { reason: `Data collection ignored for ${dl.locationHref}` };
}

const dmp: IDmpConfiguration<ICustomVariables, SiteNativeTemplate> = {
  enabled: true,
  siteId: "seondmvza",
  defaults: { collectOnPageLoad: false },
  preDataCollection,
};

export default dmp;
